import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_LIVE,
  withCredentials: true, // Enable sending cookies with cross-site requests
});
